import '../input/button-input';

import { html, LitElement, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { cache } from 'lit/directives/cache.js';
import { trapFocus, releaseFocus } from '../../_utils/trap-focus';

@customElement('mobile-nav')
export class MobileNav extends LitElement {

	// Props

	@property({ type: Boolean, reflect: true })
	open: boolean = false;

	@state()
	_body: string = '';

	// Lifecycle Hooks

	firstUpdated() {

		// add classes
		this.classList.add('MobileNav');

		// slots
		const slot: HTMLElement = this.querySelector('[slot="body"]');
		this._body = slot.innerHTML;
		slot.remove();

		document.addEventListener('navvisible', () => {
			this.classList.remove('is-visible');
		});
		document.addEventListener('navhidden', () => {
			this.classList.add('is-visible');
		});

	}

	// Render

	render() {
		return html`
			<nav class="MobileNav-nav" data-section="home">
				<div class="MobileNav-header">
					<div class="MobileNav-homeButton">
						<a title="Swiss Institute" href="/">
							<svg-icon name="logo">
						</a>
					</div>
					<div class="MobileNav-toggleWrapper">
						${ this.buttonTemplate() }
					</div>
				</div>
				${ this.open ? cache(unsafeHTML(this._body)) : '' }
			</nav>
		`;
	}

	createRenderRoot() { 
		return this;
	}

	// Templates

	buttonTemplate(): TemplateResult {
		return (this.open)
			? html`
				<button-input
					name="mobile-menu"
					@click="${() => this._toggle() }"
					icon="close">
				</button-input>
			`
			: html`
				<button-input
					name="mobile-menu"
					@click="${() => this._toggle() }"
					icon="hamburger">
				</button-input>
			`;
	}

	// Methods

	private _toggle() {
		this.open = !this.open;
		if (this.open) {
			trapFocus(this);
		} else {
			releaseFocus();
		}
	}

}